export enum CellLayout {
  None,
  EmptyOffer,
  PossibleLoading,
  Loading,
  AdditionalInfo
}
